import { DynamicForm, FieldVariant, SelectOption } from '@/components/form-builder/form-builder.types';
import { CommitteeRepository } from '@/store/committee-state/committee-state.repository';
import { ContractingAuthorityRepository } from '@/store/contracting-authority-state/contracting-authority-state.repository';

interface getMemberFormObjectProps {
  store: CommitteeRepository | ContractingAuthorityRepository;
  membersOptions?: { label: string; value: number }[];
  isConsellierMode?: boolean;
}

export const getMemberFormObject = ({ store, membersOptions, isConsellierMode }: getMemberFormObjectProps): DynamicForm => {
  const memberfield = {
    label: isConsellierMode ? 'settings.committee.form.consellier.label' : 'settings.committee.form.members.label',
    variant: FieldVariant.MULTISELECT,
    description: isConsellierMode ? 'settings.committee.form.consellier.description' : 'settings.committee.form.members.description',
    isDisabled: store.getNestedObservable<boolean>('isDisabled', 'members'),
    isRequired: true,
    props: {
      placeholder: isConsellierMode ? 'settings.committee.form.consellier.placeholder' : 'settings.committee.form.members.placeholder',
      options: membersOptions?.map(member => {
        return { name: member.label, code: member.value };
      }),
      value: store.getObservable('membersSelected'),
      onSelectChange: (value: SelectOption[]) => {
        store.setNested(
          'dto',
          isConsellierMode ? 'consellierIds' : 'userIds',
          value?.map(member => member.code)
        );
        store.set('membersSelected', value);
      },
    },
  };

  return {
    title: 'settings.members.add.title',
    description: '',
    isHeaderHidden: true,
    grids: [
      {
        title: '',
        isHeaderHidden: true,
        gridItems: [
          {
            fields: [memberfield],
          },
        ],
      },
    ],
  };
};
